exports.components = {
  "component---src-pages-orthodesign-404-tsx": () => import("./../../../src/pages-orthodesign/404.tsx" /* webpackChunkName: "component---src-pages-orthodesign-404-tsx" */),
  "component---src-pages-orthodesign-index-tsx": () => import("./../../../src/pages-orthodesign/index.tsx" /* webpackChunkName: "component---src-pages-orthodesign-index-tsx" */)
}

